const gbpFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatCurrency = (value) => {
  // Check for null, undefined, or empty string
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  // Convert to number
  const num = Number(value);
  // If the value is not a valid number, treat as "-"
  if (isNaN(num)) {
    return "-";
  }
  // If the value is 0 (including string "0"), format as £0.00
  if (num === 0) {
    return gbpFormatter.format(0);
  }
  // Otherwise, format the value
  return gbpFormatter.format(num);
};
